import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
//----------------------------------------------------------------
import Header from "./components/Header";
import Footer from "./components/Footer";
//----------------------------------------------------------------
import Page1 from "./components/Page1";
import Page2 from "./components/Page2";
import Page3 from "./components/Page3";
import Page4 from "./components/Page4";
import Page5 from "./components/Page5";
import Page6 from "./components/Page6";
import Page7 from "./components/Page7";
import Page8 from "./components/Page8";
//-----------------------------------------------------------------
import LandingPage from "./components/LandingPage";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";

function App() {
  //---------------------------------------------------------------

  return (
    <Router>
      <div className="app__container">
        <div className="app__container__wrap">
          <Switch>
            <Route exact path="/contactus" component={ContactUs}>
              <Header />
              <ContactUs />
            </Route>

            <Route exact path="/" component={LandingPage}>
              <Header />
              <LandingPage />
            </Route>
            <Route exact path="/aboutus" component={AboutUs}>
              <Header />
              <AboutUs />
            </Route>
            <Route exact path="/page1" component={Page1}>
              <Header />
              <Page1 />
            </Route>
            <Route exact path="/page2" component={Page2}>
              <Header />
              <Page2 />
            </Route>
            <Route exact path="/page3" component={Page3}>
              <Header />
              <Page3 />
            </Route>
            <Route exact path="/page4" component={Page4}>
              <Header />
              <Page4 />
            </Route>
            <Route exact path="/page5" component={Page5}>
              <Header />
              <Page5 />
            </Route>
            <Route exact path="/page6" component={Page6}>
              <Header />
              <Page6 />
            </Route>
            <Route exact path="/page7" component={Page7}>
              <Header />
              <Page7 />
            </Route>
            <Route exact path="/page8" component={Page8}>
              <Header />
              <Page8 />
            </Route>
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
